/**
 * @generated SignedSource<<4b687ffb017961a48e3144f811f0de4c>>
 * @relayHash ddee55a803a909e0d77e00661d88dad1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7879eefdc45aba56b78d8d929aa3dbf71206455f93a7add99d76a75facdd1c24

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "7879eefdc45aba56b78d8d929aa3dbf71206455f93a7add99d76a75facdd1c24",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
